// Uint8Array转字符串
const uint8ArrayToString = (msgData) => {
  var dataString = ''
  for (var i = 0; i < msgData.length; i++) {
    dataString += String.fromCharCode(msgData[i])
  }

  return dataString
}

// 格式化http get 参数
const obj2Param = (json) => {
  if (!json) return ''
  return Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
  }).join('&')
}

// 获取设备平台
const getDevice = () => {
  let type = ''
  if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
    type = 'mobile'
  } else {
    type = 'pc'
  }
  return type
}

// 获取设备操作系统
const getDeviceSystem = () => {
  let type = ''
  if (navigator.userAgent.match(/(iPhone)/i)) {
    type = 'IOS'
  } else if (navigator.userAgent.match(/(Android)/i)){
    type = 'Android'
  } else if (navigator.userAgent.match(/(Macintosh)/i)){
    type = 'MacOS'
  } else if (navigator.userAgent.match(/(Windows)/i)){
    type = 'Windows'
  } else {
    type = '其他'
  }
  return type
}

// html转text
 const html2Text = (val) => {
  const div = document.createElement("div")
  div.innerHTML = val
  return div.textContent || div.innerText
}

// 获取预览/非预览接口前缀
 const getServiceName = (url) => {
  if (location.href.indexOf('version=') > -1) {
    url = url.replace('survey2c', 'survey')
  }
  return url
}

/**
 * @description : 获取随机字符串
 * @param        {Number} length 字符串长度，如不传则默认生成32位
 * @return       {String} str 生成的字符串
 */
function getRandomString(length = 16) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const maxLength = chars.length
  let str = ''
  for (let i = 0; i < length; i++) {
    str = str + chars.charAt(Math.floor(Math.random() * maxLength))
  }
  return str
}

export {
  uint8ArrayToString,
  obj2Param,
  getDevice,
  getDeviceSystem,
  html2Text,
  getServiceName,
  getRandomString
}



// WEBPACK FOOTER //
// ./src/utils/index.js